import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { errorMessage } from "../../../../../utils/errorMessage";

// Create an asynchronous thunk using createAsyncThunk
export const actionAdminToUpdateCurrentAccountAllowedPaymentMethods =
  createAsyncThunk(
    "updateCurrentAccountAllowedPaymentMethods",
    async (updateData, thunkAPI) => {
      // GET JWT TOKEN FROM REDUX STORE
      const token = thunkAPI.getState().adminUserToLogin.adminUserInfo.token; // Gets the current Redux state

      try {
        // Call your API function here
        const { data } = await axios.put(
          "/api/wholesale/updateCurrentAccountAllowedPaymentMethods",
          updateData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // Assuming the API response contains the data
        return data;
      } catch (error) {
        let { message } = errorMessage(error);
        throw new Error(message);
      }
    }
  );

// Define an initial state for the slice
const initialState = {
  updatedCurrentAccountAllowedPaymentMethods: null,
  loading: false,
  error: null,
};

// Create a slice using createSlice
const updateCurrentAccountAllowedPaymentMethodsSlice = createSlice({
  name: "updateCurrentAccountAllowedPaymentMethods",
  initialState,
  reducers: {
    resetUpdateCurrentAccountAllowedPaymentMethods: (state) => {
      state.updatedCurrentAccountAllowedPaymentMethods = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        actionAdminToUpdateCurrentAccountAllowedPaymentMethods.pending,
        (state) => {
          state.loading = true;
        }
      )
      .addCase(
        actionAdminToUpdateCurrentAccountAllowedPaymentMethods.fulfilled,
        (state, action) => {
          state.loading = false;
          state.updatedCurrentAccountAllowedPaymentMethods = action.payload;
        }
      )
      .addCase(
        actionAdminToUpdateCurrentAccountAllowedPaymentMethods.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        }
      );
  },
});

// Export reset method
const { resetUpdateCurrentAccountAllowedPaymentMethods } =
  updateCurrentAccountAllowedPaymentMethodsSlice.actions;

// Export the reducer
const reducerAdminToUpdateCurrentAccountAllowedPaymentMethods =
  updateCurrentAccountAllowedPaymentMethodsSlice.reducer;

// Export the async action creator for use in components
export {
  reducerAdminToUpdateCurrentAccountAllowedPaymentMethods,
  resetUpdateCurrentAccountAllowedPaymentMethods,
};
